const initState = {
  additionalEarnings: [],
  licenseEarningsData: [],
  totalLicenseEarnings: 0,
  subscriptionEarningsData: [],
  totalSubscriptionEarnings: 0,
  loader: false,
  athlete: {},
  athleteAnnualEarnings: [],
  totalEarning: 0,
  adminStats: [],
  groupchat: [],
  oneononechat: [],
  totalRefunds: {},
  refundsData: {},
  allManagers: [],
  SingleManager: null,
  adminMonthlyEarnings: [],
  lastDocumentOneononechat: "",
  hasMoreOneononechat: true,
  lastDocumentGroupchat: "",
  hasMoreGroupchat: true,
  transactions: [],
  userStats: {},
  distributionStats: [],
};

const additionalEarningReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADMIN_MONTHLY_EARNING_BY_YEAR":
      return {
        ...state,
        adminMonthlyEarnings: action.payload,
      };
    case "ALL_MANAGERS":
      return {
        ...state,
        allManagers: action.payload,
      };
    case "GET_MANAGER":
      return {
        ...state,
        SingleManager: action.payload,
      };
    case "TOTAL-REFUNDS":
      return {
        ...state,
        totalRefunds: action.payload.totalData,
        refundsData: action.payload.data,
      };
    case "GET_ADDITIONAL_EARNING":
      return {
        ...state,
        additionalEarnings: action.payload,
      };
    case "GET_LICENSE_EARNINGS":
      return {
        ...state,
        licenseEarningsData: action.payload.data,
        totalLicenseEarnings: action.payload.totalEarnings,
      };
    case "GET_SUBSCRIPTION_EARNINGS":
      return {
        ...state,
        subscriptionEarningsData: action.payload.data,
        totalSubscriptionEarnings: action.payload.totalEarnings,
      };

    case "GET-ATHLETE":
      return {
        ...state,
        athlete: action.payload,
      };
    case "ATHLETE_ANNUAL-EARNING":
      return {
        ...state,
        athleteAnnualEarnings: action.payload,
      };
    case "ADMIN_STATS":
      return {
        ...state,
        adminStats: action.payload,
      };
    case "LOADER":
      return {
        ...state,
        loader: action.payload,
      };
    case "GET_GROUPCHAT":
      return {
        ...state,
        groupchat: action.payload.data,
        lastDocumentGroupchat: action.payload.lastDocument,
        hasMoreGroupchat: action.payload.hasMore,
      };
    case "MORE_GET_GROUPCHAT":
      return {
        ...state,
        groupchat: [...state.groupchat, ...action.payload.data],
        lastDocumentGroupchat: action.payload.lastDocument,
        hasMoreGroupchat: action.payload.hasMore,
      };
    case "GET_ONEONONECHAT":
      return {
        ...state,
        oneononechat: action.payload.data,
        lastDocumentOneononechat: action.payload.lastDocument,
        hasMoreOneononechat: action.payload.hasMore,
      };
    case "MORE_GET_ONEONONECHAT":
      return {
        ...state,
        oneononechat: [...state.oneononechat, ...action.payload.data],
        lastDocumentOneononechat: action.payload.lastDocument,
        hasMoreOneononechat: action.payload.hasMore,
      };
    case "SET_COINS_STATS":
      return {
        ...state,
        transactions: action.payload,
      };
    case "CLEAR_TRANSACTIONS":
      return {
        ...state,
        transactions: [],
      };
    case "GET_USER_STATS":
      return {
        ...state,
        userStats: action.payload,
      };

    case "SET_DISTRIBUTED_COINS_STATS":
      return {
        ...state,
        distributionStats: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default additionalEarningReducer;
